export default "__VITE_ASSET__CA43_bqs__"